import api from '@/api';
import store from '@/store';
import router from '@/router';
// sidebar模块状态
const state = {
    // 是否收起
    isCollapse: false,
    // 激活的菜单项
    activeMenu: '',
    // 侧边栏菜单项
    menuItems: [],
    //新钱包账单
    walletListNew: [
        {
            name: '/walletNew/balance-manage/add-balance',
            text: '资金管理',
            children: [
                {
                    name: '/walletNew/balance-manage/add-balance',
                    text: '充值/转入'
                },
                // {
                //     name: '/walletNew/balance-manage/less-balance',
                //     text: '提现/转出'
                // }
            ]
        },
        {
            name: '/walletNew/wallet-manage/wallet-bill',
            text: '钱包管理',
            children: [
                {
                    name: '/walletNew/wallet-manage/wallet-bill',
                    text: '账单'
                },
                // {
                //     name: '/walletNew/operationAccount',
                //     text: '钱包'
                // },
                // {
                //     name: '/walletNew/unionAccount',
                //     text: '零钱'
                // },
                // {
                //     name: '/walletNew/wallet-manage/credit-bill',
                //     text: '授信'
                // },
                // {
                //     name: '/walletNew/subOperationAccount',
                //     text: '子账户'
                // }
            ]
        },
        {
            name: '/walletNew/setting',
            text: '设置',
            children: [
                {
                    name: '/walletNew/setting',
                    text: '安全及系统设置'
                },
                // {
                //     name: '/walletNew/user/authorization',
                //     text: '授权'
                // },
                {
                    name: '/walletNew/relateMerchants',
                    text: '关联商家'
                },
                // {
                //     name: '/walletNew/invoiceApplication',
                //     text: '开票申请'
                // }
            ]
        }
    ],
    //新基本商户默认菜单
    basicMerchantList: [
        {
            name: '/merchantNew/transaction',
            text: '交易管理',
            children: [
                {
                    name: '/merchantNew/transaction',
                    text: '消费'
                },
                {
                    name: '/merchantNew/refund',
                    text: '退款'
                },
                {
                    name: '/merchantNew/settle/order',
                    text: '结算'
                }
            ]
        },
        {
            name: '/merchantNew/charge',
            text: '资金管理',
            children: [
                {
                    name: '/merchantNew/withdrawal',
                    text: '提现/转出'
                }
            ]
        },
        {
            name: '/merchantNew/baseAccount',
            text: '账单',
            children: [
                {
                    name: '/merchantNew/baseAccount',
                    text: '基本账户'
                },
                {
                    name: '/merchantNew/unionAccount',
                    text: '零钱账户'
                }
            ]
        },
        {
            name: '/merchantNew/setting',
            text: '设置',
            children: [
                {
                    name: '/merchantNew/setting',
                    text: '安全及系统设置'
                },
                {
                    name: '/merchantNew/user/authorization',
                    text: '商户授权'
                },
                // {
                //     name: '/merchantNew/relateMerchant',
                //     text: '关联商户'
                // },
                // {
                //     name: '/merchantNew/bindBankAccount',
                //     text: '绑定银行账户'
                // }
            ]
        }
    ],
    //新产品中心默认菜单
    productList: [],
    // 已保存菜单
    menuList: [],
    // 是否为商户身份
    isMerchant: false,
    //是否新支付系统
    isNewpaycenter: true,
    // 是否显示余额
    isShowSum: 'N',
    //当前模块 0基本商户  1产品中心
    moduleNum: 0,
    // 是否显示融资
    isShowFinancing: false
};

// sidebar模块mutations
const mutations = {
    /**
     * 切换侧边栏展开状态
     * @param state
     */
    toggle(state) {
        state.isCollapse = !state.isCollapse;
    },
    /**
     * 设置激活菜单项
     * @param state
     * @param value
     */
    setActiveMenu(state, value) {
        state.activeMenu = value;
    },
    /**
     * 设置侧边栏菜单项
     * @param state
     * @param value
     */
    setMenuItems(state, value) {
        state.menuItems = value;
        state.menuList = value;
    },
    /**
     * 是否显示余额
     * @param state
     */
    setIsShowSum(state, value) {
        state.isShowSum = value;
    },
    /**
     * 是否显示融资
     * @param state
     */
    setIsShowFinancing(state, value) {
        state.isShowFinancing = value;
    },
    /**
     * 已保存菜单
     * @param state
     */
    setMenuList(state, value) {
        state.menuList = value;
    },
    /**
     * 是否为商户身份
     * @param state
     */
    setIsMerchant(state, value) {
        state.isMerchant = value;
    },
    /**
     * 是否为新商户系统
     * @param state
     */
    setisNewpaycenter(state, value) {
        state.isNewpaycenter = value;
    },
    /**
     *
     *设置当前模块
     */
    setModuleNum(state, value) {
        state.moduleNum = value;
    }
};

// cache模块actions
const actions = {
    /**
     * 角色菜单
     * @param context
     * @param value
     */
    setSumMenuItems({ state, commit, rootState }) {
        return new Promise(async (resolve, reject) => {
            // 当前页面为redirect则阻止 防止商户身份误判
            if (['/error', '/redirect'].includes(router.currentRoute.path)) return resolve();
            const { walletListNew } = state;
            // 是否为商户身份
            const curMerchant =
                router.currentRoute.path &&
                (router.currentRoute.path.includes('merchant/') || router.currentRoute.path.includes('merchantNew/'));
            //是否为新支付系统
            const newpaycenter = router.currentRoute.path && router.currentRoute.path.includes('New/');
            // 保存当前身份
            commit('setIsMerchant', curMerchant);
            commit('setisNewpaycenter', newpaycenter);
            // 商户模块34 钱包模块33
            const orgCatetoryId = curMerchant ? 34 : 33;

            // 先获取是否显示授信账单||余额账单||融资账单标识
            try {
                if(!newpaycenter){
                    const queryWalletInfo = await api.walletService.queryWalletInfo();
                    const merchantdetail = await api.walletService.getMerchantdetail();
                    const { isShow: isShowSum = 'N', isOpenCredit = false } = queryWalletInfo.data;
                    const { exhibitionInfo } = merchantdetail.data;
                }
                store.commit('user/setIsOpenCredit', isOpenCredit);
                commit('setIsShowSum', isShowSum);
                commit('setIsShowFinancing', Boolean(exhibitionInfo));
            } catch (err) {
                store.commit('user/setIsOpenCredit', false);
                commit('setIsShowSum', 'N');
                commit('setIsShowFinancing', false);
            }
            // 默认配置菜单
            let menusData = [];
            const productList = [
                {
                    name: '/merchantNew/productCenter',
                    text: '首页'
                },
                {
                    name: '/merchantNew/credit/tradeList',
                    text: '授信',
                    children: [
                        {
                            name: '/merchantNew/credit/tradeList',
                            text: '授信交易'
                        },
                        {
                            name: '/merchantNew/creditQuota',
                            text: '授信额度'
                        }
                    ]
                },
                // {
                //     name: '/merchantNew/loansAbroad',
                //     text: '在外货款',
                //     children: [
                //         {
                //             name: '/merchantNew/loansAbroad',
                //             text: '在外货款'
                //         },
                //         {
                //             name: '/merchantNew/settle',
                //             text: '结清申请'
                //         },
                //         {
                //             name: '/merchantNew/lateCharge',
                //             text: '逾期罚息'
                //         },
                //         {
                //             name: '/merchantNew/badDebt',
                //             text: '坏账核销'
                //         }
                //     ]
                // },
                {
                    name: '/merchantNew/subAccountManage',
                    text: '子账户',
                    children: [
                        {
                            name: '/merchantNew/subAccountManage',
                            text: '子账户管理'
                        },
                        {
                            name: '/merchantNew/orderManage',
                            text: '订单管理'
                        }
                    ]
                },
                {
                    name: '/merchantNew/offlinePay',
                    text: '线下支付',
                    children: [
                        {
                            name: '/merchantNew/offlinePay',
                            text: '线下支付流水'
                        },
                        {
                            name: '/merchantNew/offlinePayConfig',
                            text: '线下支付配置'
                        }
                    ]
                }
            ]
            if (curMerchant && !newpaycenter) {
                //商户 && 旧支付系统
                menusData = walletListNew;
            } else if (!curMerchant && !newpaycenter) {
                menusData = walletListNew;
            } else if (curMerchant && newpaycenter) {
                //商户 && 新支付系统
                if (state.moduleNum === 0) {
                    //基本商户
                    menusData = state.basicMerchantList;
                } else if (state.moduleNum === 1) {
                    //产品中心
                    menusData = productList;
                }
            } else if (!curMerchant && newpaycenter) {
                //非商户 && 新支付系统
                menusData = state.walletListNew;
            }
            // 再根据角色菜单调整菜单
            try {
                const { data = [] } = await api.commonService.getCommonCategoryResources({ orgCatetoryId });
                if (!newpaycenter) {
                    //商户 && 旧支付系统
                    //只筛选旧系统菜单
                    menusData =
                        (data &&
                            data.filter(key => {
                                return !key.code.includes('new:');
                            })) ||
                        [];
                } else if (curMerchant && newpaycenter) {
                    //商户 && 新支付系统
                    if (state.moduleNum === 0) {
                        //基本商户
                        menusData = state.basicMerchantList;
                    } else if (state.moduleNum === 1) {
                        //产品中心
                        menusData = productList;
                    }
                } else if (!curMerchant && newpaycenter) {
                    
                    //非商户 && 新支付系统
                    menusData = state.walletListNew;
                    //判断菜单是否显示
                    api.walletServiceNew.walletMenuShow().then(res => {
                        if(res.data.code === 200){
                            let menuObj = res.data?.data;
                            let walletArr = [{
                                name: '/walletNew/wallet-manage/wallet-bill',
                                text: '账单'
                            }]
                            if(menuObj.jsbWallet.exist){
                                walletArr.push({
                                    name: '/walletNew/operationAccount',
                                    text: '钱包'
                                });
                            }
                            if(menuObj.unionChange.exist){
                                walletArr.push({
                                    name: '/walletNew/unionAccount',
                                    text: '零钱'
                                });
                            }
                            if(menuObj.credit.exist){
                                walletArr.push({
                                    name: '/walletNew/wallet-manage/credit-bill',
                                    text: '授信'
                                });
                            }
                            if(menuObj.jsbFinancing.exist){
                                walletArr.push({
                                    name: '/walletNew/subOperationAccount',
                                    text: '子账户'
                                });
                            }
                            menusData[1].children = walletArr;
                            if(!menuObj.jsbWallet.exist && !menuObj.unionChange.exist && !menuObj.credit.exist && !menuObj.jsbFinancing.exist){
                                menusData[0] = {}
                            }
                        }else{
                            menusData[1].children = [{
                                name: '/walletNew/wallet-manage/wallet-bill',
                                text: '账单'
                            }]
                            menusData[0] = {}
                        }
                    })
                }
                commit('setMenuItems', menusData);
            } catch (err) {
                commit('setMenuItems', menusData);
            }
        });
    }
};
// sidebar模块getters
const getters = {
    /**
     * 切换侧边栏展开状态
     * @param state
     * @param getters
     * @param rootState
     */
    menuItems(state, getters, rootState) {
        const { menuItems: menusData, isShowSum, isShowFinancing } = state;
        const { isOpenCredit } = rootState.user;
        return handleMenus({ menusData, isOpenCredit, isShowSum, isShowFinancing });
    },
    isShowSum(state) {
        return state.isShowSum;
    },
    isMerchant(state) {
        return state.isMerchant;
    },
    isShowFinancing(state) {
        return state.isShowFinancing;
    }
};

// 过滤授信账单||余额账单 isOpenCredit是否有授信账单 isShowSum是否有余额账单 isShowFinancing是否有融资账单
const handleMenus = ({ menusData, isOpenCredit = false, isShowSum = 'N', isShowFinancing = false }) => {
    const menus = JSON.parse(JSON.stringify(menusData));
    return menus.reduce((oldArr, item) => {
        let { name, text, routeUrl, children, resourceType } = item;
        // 适配接口返回字段和定义字段
        if (!resourceType) {
            resourceType = 'MENU';
        } else {
            text = name;
            name = routeUrl;
        }
        children =
            children && children.length > 0
                ? handleMenus({ menusData: children, isOpenCredit, isShowSum, isShowFinancing })
                : null;
        // 有授信账单||余额账单||融资账单权限且该菜单是授信账单||余额账单||融资账单
        const isMenusShow =
            (!isOpenCredit && text === '授信账单') ||
            (isShowSum === 'N' && text === '余额账单') ||
            (!isShowFinancing && text === '融资账单');
        return resourceType === 'MENU' && !isMenusShow ? oldArr.concat({ text, name, children }) : oldArr;
    }, []);
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
